/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Auth } from '@modules/auth/domain/auth.entity';
import { MessageService } from 'primeng/api';
import { BehaviorSubject, catchError, tap, throwError } from 'rxjs';

export type LoginState = 'USER_VALIDATION' | 'SIGN_IN' | 'SIGN_IN_CONFIRM' | 'SIGNED_IN' | 'RESET_PASSWORD' | 'ERROR' | 'SEND_RECOVER_MAIL' | 'VERIFY_CODE' | 'FIRST_LOGIN'

@Injectable({ providedIn: 'root' })
export class LoginService {
  // state: LoginState;
  auth: Auth;
  private stateSubject = new BehaviorSubject<string>('SIGN_IN');
  public state$ = this.stateSubject.asObservable();
  // private sessionEndpoint = `${environment.backendUrl}sessionmanager/connect365/api/v1/session-manager${environment.protected}`;
  private sessionEndpoint = `${environment.backendUrl}sessionmanager/connect365/api/v1/session-manager${environment.protected}`;
  private sessionMetaData = `${environment.backendUrl}portal/non-federated/connect365/api/v1/user-metadata${environment.protected}`;
  private endpoint = `${environment.backendUrl}portal/non-federated/connect365/api/v1/`
  token: any

  constructor(private http: HttpClient, private messageService: MessageService) {
    const saved = localStorage.getItem('authState');
    if (saved) {
      this.stateSubject.next(saved);
    }

    this.state = 'USER_VALIDATION';
    this.auth = {
      username: '',
      password: '',
      code: ''
    };


  }

  get state(): string {
    return this.stateSubject.value;
  }

  set state(value: string) {
    this.stateSubject.next(value);
    localStorage.setItem('authState', value);
  }



  sendResetPasswordRequest(email: string) {
    const body = {
      email: email
    }
    localStorage.setItem('resetEmail', email)
    return this.http.post(this.endpoint + 'password-reset-request/protected', body, {
    }).pipe(
      tap((res) => {
      }),
      catchError(error => {
        console.error('error al conseguir datos', error)
        return throwError(() => error)
      })
    )
  }

  verifyCode(code: string, email: string) {
    const body = {
      otp: code,
      email: email
    }
    return this.http.post(this.endpoint + 'password-reset-verify/protected', body)
  }

  getMetaData() {
    const body = {
      email: localStorage.getItem('usernameOrEmail'),
      "includeRecaptcha": true,
    }
    return this.http.post(this.sessionMetaData, body, {
    }).pipe(
      tap((res) => {
      }),
      catchError(error => {
        console.error('error al conseguir datos', error)
        return throwError(() => error)
      })
    )
  }

  changePassword(currentPassword: string, newPassword: string) {

    const body = {
      "email": localStorage.getItem('usernameOrEmail'),
      "currentPassword": currentPassword,
      "newPassword": newPassword
    }

    return this.http.post(this.endpoint + `change-password${environment.protected}`, body, {
    }).pipe(
      tap((res) => {
        this.messageService.add({
          life: 10000,
          severity: 'success',
          summary: 'Contraseña Cambiada',
          detail: '¡La contraseña ha sido cambiada existosamente!, por favor inicie sesión nuevamente',
        });
        sessionStorage.removeItem('userMetadata');
        localStorage.removeItem('userSession')
        this.state = 'USER_VALIDATION'
      }),
      catchError(error => {
        this.messageService.add({
          life: 10000,
          severity: 'error',
          summary: 'Error al cambiar contraseña',
          detail: error?.error?.errors[0]?.extensions?.message,
        });

        console.error('error al conseguir datos', error)
        return throwError(() => error)
      })
    )
  }

  resetPaswword(newPassword: string) {
    const body = {
      "email": localStorage.getItem('usernameOrEmail'),
      "newPassword": newPassword
    }

    return this.http.post(this.endpoint + `change-password${environment.protected}`, body, {
    }).pipe(
      tap((res) => {
        this.messageService.add({
          life: 10000,
          severity: 'success',
          summary: 'Contraseña Cambiada',
          detail: '¡La contraseña ha sido cambiada existosamente!, por favor inicie sesión nuevamente',
        });
        sessionStorage.removeItem('userMetadata');
        localStorage.removeItem('userSession')
        this.state = 'USER_VALIDATION'
      }),
      catchError(error => {
        this.messageService.add({
          life: 10000,
          severity: 'error',
          summary: 'Error al cambiar contraseña',
          detail: error?.error?.errors[0]?.extensions?.message,
        });
        console.error('error al conseguir datos', error)
        return throwError(() => error)
      })
    )
  }
}
